import { Skeleton } from "antd";
import styled from "styled-components";

export const TitleContainer = styled.div`
  width: 70%;
  margin: 50px 0 25px 20px;

  > * {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  @media only screen and (max-width: 767px) {
    width: 100%;
    text-align: center;
    margin: 20px 0;

    > * {
      white-space: pre-line;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
`;

export const TitleSkeleton = styled(Skeleton)`
  width: 60%;
  margin: 50px 0 25px 20px;

  @media only screen and (max-width: 767px) {
    width: 90%;
    margin: 20px 0;
    margin-left: 20%;
  }
`;
